import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface SkipConvertingQuickSearchSelectProps {
  value?: string | null;
  onChange(value: string | null): void;
}

export default function SkipConvertingQuickSearchSelect(props: SkipConvertingQuickSearchSelectProps): React.JSX.Element {
  const { i18n } = useTranslation();

  // Internal state to track current value, since we won't get updates when the preference changes
  const [internalValue, setInternalValue] = useState<string>(props.value === "on" ? "on" : "off");

  useEffect(() => {
    const newValue = props.value === "on" ? "on" : "off";
    setInternalValue(newValue);
  }, [props.value]);

  function handleValueChange(event: SelectChangeEvent<string>): void {
    const newValue = event.target.value || null;
    const normalizedValue = newValue === "on" ? "on" : "off";

    // Update internal state, since we won't get an update when the preference changes
    setInternalValue(normalizedValue);

    props.onChange(normalizedValue);
  }

  return (
    <Select
      fullWidth
      variant="outlined"
      displayEmpty
      value={internalValue}
      onChange={handleValueChange}
    >
      <MenuItem key={"off"} value={"off"}>
        {i18n.t("profile-page.skip-converting-quicksearch-off")}
      </MenuItem>
      <MenuItem key={"on"} value={"on"}>
        {i18n.t("profile-page.skip-converting-quicksearch-on")}
      </MenuItem>
    </Select>
  )
}